import { Injectable } from '@angular/core';

@Injectable()
export class ProgressIndicatorService {

    progress!: boolean;

    constructor() {
    }
}
